import { ApiProperty } from '@nestjs/swagger'
import { IsEmail, IsNotEmpty, IsString, MinLength } from 'class-validator'

export class ResetPasswordRequest {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	token: string

	@ApiProperty({ type: String, format: 'password' })
	@IsNotEmpty()
	@IsString()
	@MinLength(8)
	password: string
}

export class RequestResetPasswordRequest {
	@ApiProperty({ type: String, format: 'email' })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	email: string
}

export class UpdatePasswordRequest {
	@ApiProperty({ type: String, format: 'password' })
	@IsNotEmpty()
	@IsString()
	currentPassword: string

	@ApiProperty({ type: String, format: 'password' })
	@IsNotEmpty()
	@IsString()
	@MinLength(8)
	newPassword: string
}
